<template>
  <div>
    <template v-if="!loading">
      <h1>{{ $lang("報名表") }}</h1>
      <b-container class="dashed">
        <div>
          <template v-for="(item, index) in list">
            <add-items
              :disabled="is_perview"
              :item="item"
              :index="index"
              :isplayer="index === 0"
              :key="index"
              @click="handlerAdd(index)"
            >
            </add-items>
          </template>
        </div>
        <div style="margin-bottom:20px;">
          <b-col md="6" class="px-0">
            <b-form-group
              horizontal
              :label-cols="4"
              :label="$lang('澳門手機號碼：')"
            >
              <b-form-input
                ref="phone"
                type="text"
                v-model="tel"
                id="phone"
                name="phone"
                data-vv-as="phone"
                :class="errors.has('phone') && 'is-invalid'"
                v-validate="'required|mobile'"
                :placeholder="$lang('請輸入澳門手機號碼')"
                :disabled="is_perview"
              />
              <b-form-invalid-feedback :state="errors.has('phone')">
                {{ errors.first("phone") }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col v-if="!is_perview" md="6" class="px-0">
            <b-form-group
              horizontal
              :label-cols="4"
              :label="$lang('確認手機號碼：')"
            >
              <b-form-input
                :disabled="is_perview"
                ref="repasstel"
                type="text"
                v-model="confirmTel"
                name="repasstel"
                data-vv-as="repasstel"
                id="repasstel"
                :class="errors.has('repasstel') && 'is-invalid'"
                v-validate="'required|confirmed:phone'"
                :placeholder="$lang('請確認手機號碼')"
              />
              <b-form-invalid-feedback :state="errors.has('repasstel')">
                {{ errors.first("repasstel") }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </div>
        <b-form-group>
          <b-form-checkbox
            :disabled="is_perview"
            name="healthCheck2"
            v-model="agree"
            :class="errors.has('healthCheck2') && 'is-invalid'"
            v-validate="{ required: true }"
          >
            <span
              class="lbl"
              style="color: red"
              v-html="$lang('TEXT_AGREE')"
            ></span>
          </b-form-checkbox>
          <b-form-invalid-feedback :state="errors.has('healthCheck2')">
            {{ errors.first("healthCheck2") }}
          </b-form-invalid-feedback>
        </b-form-group>
        <div v-if="!is_perview">
          <b-btn @click="submit">{{ $lang("BTN_YES") }}</b-btn>
          <b-btn @click="cancle">{{ $lang("TEXT_RESET") }}</b-btn>
          <b-btn
            variant="success"
            @click="$router.push({ name: 'family-day-2019' })"
            >{{ $lang("TITLE_RETURN_INDEX") }}</b-btn
          >
          <router-link
            :to="{ name: 'family-game-form' }"
            class="btn btn-success btn-round"
            >{{ $lang("查看家庭成員") }}</router-link
          >
        </div>
        <div v-else>
          <b-btn
            variant="success"
            @click="$router.push({ name: 'family-day-2019' })"
            >{{ $lang("TITLE_RETURN_INDEX") }}</b-btn
          >
        </div>
      </b-container>
      <b-modal ref="seleted" id="#selete" :title="title">
        <b-form-select v-model="currentItem">
          <option
            :value="item"
            v-for="(item, index) in members"
            :key="index"
            :disabled="item.disabled"
          >
            {{ changeName(item) }}
          </option>
        </b-form-select>
        <div slot="modal-footer">
          <b-btn variant="success" @click="hideModel">{{
            $lang("BTN_YES")
          }}</b-btn>
          <b-btn variant="info" @click="clean">{{ $lang("清除") }}</b-btn>
        </div>
      </b-modal>
    </template>
    <template v-else>
      <div class="spinner">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </template>
  </div>
</template>

<script>
const list_empty = () => {
  return [
    {
      idNumber: "",
      name: null,
      isAdult: true,
      bornAt: null,
      isMain: false,
      uuid: "",
    },
    {
      idNumber: "",
      name: null,
      isAdult: true,
      bornAt: null,
      isMain: false,
      uuid: "",
    },
    {
      idNumber: "",
      name: null,
      isAdult: true,
      bornAt: null,
      isMain: false,
      uuid: "",
    },
    {
      idNumber: "",
      name: null,
      isAdult: true,
      bornAt: null,
      isMain: false,
      uuid: "",
    },
  ];
};
import AddItems from "@/components/AddItems";
import { $apis } from "@/helper";

export default {
  components: {
    AddItems,
  },
  created() {
    var id = this.$route.params.slug;
    this.id = id;
    this.familyRecordDetail(id);
    this.getFamilyList(id);
  },
  methods: {
    changeName(item) {
      let name;
      if (
        (item.firstName || item.lastNameOther) &&
        (item.lastName || item.firstNameOther)
      )
        name =
          (item.firstName || item.lastNameOther) +
          " " +
          (item.lastName || item.firstNameOther);
      else name = null;
      return name;
    },
    // 获取报名表数据
    familyRecordDetail(id) {
      this.loading = true;
      $apis.family
        .familyRecordDetail({
          id: id,
        })
        .then((resp) => {
          this.tel = resp.data.record.tel;
          // this.confirmTel=resp.data.record.tel
          let item = resp.data.record;
          this.filtersList(item.gamers).forEach((item, index) => {
            this.list.splice(index, 1, item);
          });
          // 判断是否是参赛者
          this.players = this.list.filter((item) => item.isMain);
          this.filtersMembers();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getFamilyList(id) {
      $apis.family
        .familyList({ id: id })
        .then((resp) => {
          this.members = resp.data.members;
          this.filtersMembers();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openModel() {
      this.currentItem = {
        bornAt: "",
        firstName: "",
        gender: "",
        idNumber: "",
        isAdult: true,
        is_used: false,
        lastName: "",
        value: "",
      };
      this.$refs["seleted"].show();
    },
    hideModel() {
      this.$refs["seleted"].hide();
      this.changelist(this.currentIndex, this.currentItem);
      this.currentIndex = -1;
    },
    clean() {
      this.currentItem = {
        bornAt: "",
        firstName: "",
        gender: "",
        idNumber: "",
        isAdult: true,
        is_used: false,
        lastName: "",
        value: "",
      };
      this.hideModel();
    },
    changelist(index, currentItem) {
      let idNumber = currentItem.idNumber;
      this.list.splice(index, 1, {
        name: this.changeName(currentItem),
        idNumber: currentItem.idNumber,
        isAdult: currentItem.isAdult,
        bornAt: currentItem.bornAt,
        uuid: currentItem.uuid,
      });
      this.sign.splice(index, 1, idNumber);
      this.filtersMembers(index);
    },
    filtersMembers(indexs) {
      this.sign = this.list.map((item) => item.uuid);
      this.members.forEach((item, index) => {
        var number = this.sign.toString().indexOf(item.uuid);
        this.players.forEach((player) => {
          if (item.uuid == player.uuid) {
            item.is_used = false;
          }
        });
        if (
          number != -1 ||
          (indexs == 0 && item.is10AgeLater) ||
          (indexs > 0 && !item.is10AgeLater) ||
          (item.is_used && this.currentIndex == 0)
        ) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
      console.log(this.players);
    },
    handlerAdd(index) {
      if (this.is_perview) return;
      this.currentIndex = index;
      this.openModel();
      this.filtersMembers(index);
    },
    validateForm() {
      let flag = false;
      let number = 0;
      let adult = 0;
      let child = 0;
      let isplayers = this.list[0];
      let bornAt = isplayers && isplayers.bornAt;
      let year = new Date(bornAt).getFullYear();
      console.log(year);
      this.list.forEach((item) => {
        if (item.uuid) {
          number++;
          if (item.isAdult) {
            adult++;
          } else {
            child++;
          }
        }
      });
      if (number >= 3) {
        flag = true;
      } else {
        this.notification.warning(this.$lang("10020"));
        flag = false;
        return flag;
      }
      if (year >= 2016 && year <= 2024) {
        flag = true;
      } else {
        this.notification.warning(this.$lang("10018"));
        flag = false;
        return flag;
      }
      if (adult >= 1) {
        flag = true;
      } else {
        this.notification.warning(this.$lang("10027"));
        flag = false;
        return flag;
      }
      if (this.agree === true) {
        flag = true;
      } else {
        this.notification.warning(this.$lang("10051"));
        flag = false;
        return flag;
      }
      return flag;
    },
    submit() {
      this.$validator.validate().then((res) => {
        if (res) {
          if (this.validateForm()) {
            var params = [];
            this.list.forEach((item) => {
              if (item.uuid) {
                params.push(item.uuid);
              }
            });
            // 新增报名表数据
            if (this.is_new) {
              $apis.family
                .newFamilyRecord({ ...params, agree: this.agree })
                .then((resp) => {
                  if (resp.code === 0) {
                    this.notification.success(this.$lang("成功添加報名表"));
                    this.$router.push({
                      name: "family-day-2019",
                    });
                  }
                })
                .catch((err) => {
                  this.notification.error(this.$lang(err.message));
                  // alert(err.message)
                });
            }
            if (this.is_edit) {
              var params = [];
              this.list.forEach((item) => {
                if (item.uuid) {
                  params.push(item.uuid);
                }
              });
              var value = {
                id: this.id,
                idNumbers: params,
              };
              // // 修改报名表数据
              $apis.family
                .updateFamilyRecord({ ...value, agree: this.agree,tel:this.tel })
                .then((resp) => {
                  this.notification.success(this.$lang("成功更新報名表"));
                  // alert(this.$lang('成功更新報名表'))
                  this.$router.push({
                    name: "family-day-2019",
                  });
                })
                .catch((err) => {
                  var teamMembers = err.data;
                  Object.keys(teamMembers).map((key) => {
                    console.log(teamMembers[key].message);
                    this.notification.error(
                      this.$lang(teamMembers[key].message)
                    );
                  });
                  reject(false);

                  // alert(err.message)
                });
            }
          }
        } else {
        }
      });
    },
    cancle() {
      this.sign = [];
      this.filtersMembers();
      this.list = list_empty();
    },
    filtersList(list) {
      return list.map((item) => {
        return {
          name: this.changeName(item),
          isAdult: item.isAdult,
          idNumber: item.idNumber,
          bornAt: item.bornAt,
          isMain: item.isMain,
          uuid: item.uuid,
        };
      });
    },
  },
  computed: {
    title() {
      return this.currentIndex === 0
        ? this.$lang("選擇参赛兒童")
        : this.$lang("選擇家庭成員");
    },
    is_perview() {
      return this.$route.meta.type === "perview";
    },
    is_edit() {
      return this.$route.meta.type === "edit";
    },
    is_new() {
      return this.$route.meta.type === "new";
    },
  },
  data() {
    return {
      tel: "",
      confirmTel: "",
      agree: true,
      loading: true,
      id: null,
      text: "",
      sign: [],
      currentItem: [],
      currentIndex: -1,
      preView: false,
      members: [],
      players: [],
      cancleId: 0,
      recordsLength: 0,
      list: list_empty(),
    };
  },
};
</script>
